import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const RouterLight = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_11317_15632)">
            <path
              d="M15.1359 1.36816H15.5359L16.9988 12.9501H13.9368L15.1359 1.36816Z"
              fill="white"
              stroke="black"
              stroke-width="0.8"
              stroke-linejoin="round"
            />
            <path
              d="M3.80849 1.41602H4.20849L5.67136 12.9383H2.60938L3.80849 1.41602Z"
              fill="white"
              stroke="black"
              stroke-width="0.8"
              stroke-linejoin="round"
            />
            <path
              d="M0.5 13.999C0.5 13.1706 1.17157 12.499 2 12.499H18C18.8284 12.499 19.5 13.1706 19.5 13.999V17.999C19.5 18.8275 18.8284 19.499 18 19.499H2C1.17157 19.499 0.5 18.8275 0.5 17.999V13.999Z"
              fill="white"
              stroke="black"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <rect
              x="2.36987"
              y="15.1465"
              width="15.1152"
              height="2"
              rx="1"
              fill="white"
              stroke="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_11317_15632">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </SVGIconRender>
  );
};

export default RouterLight;
